module.exports = __webpack_public_path__ + "static/media/almac.92c634c9.png";